var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0932617 16.5266V58.1633C0.0932617 59.7634 0.728915 61.298 1.86038 62.4295C2.99185 63.561 4.52645 64.1966 6.12659 64.1966H84.5566C87.8899 64.1966 90.1266 61.4966 90.1266 58.1633L90.3333 16.5266L48.1366 40.6666C46.2733 41.7399 44.1899 41.9566 42.3266 40.8833L0.0932617 16.5266Z",
    fill: "#E6B262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5202 62.5L58.5435 34.7033L48.1368 40.6667C46.2735 41.74 44.1902 41.9567 42.3268 40.8833L31.0835 34.39L1.85352 62.42C2.41272 62.9843 3.07842 63.432 3.81199 63.7369C4.54556 64.0419 5.3324 64.1982 6.12685 64.1967H84.5568C85.2995 64.2078 86.0362 64.0624 86.7191 63.7701C87.4019 63.4778 88.0156 63.0451 88.5202 62.5Z",
    fill: "#D28A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3333 5.23334H6.0333C5.23178 5.23365 4.43834 5.39359 3.69929 5.7038C2.96023 6.01402 2.29036 6.46831 1.72874 7.04017C1.16712 7.61203 0.725005 8.29 0.42819 9.03454C0.131376 9.77908 -0.0141968 10.5753 -3.40224e-05 11.3767L0.0932993 16.5267L41.8666 40.6667C43.7233 41.7333 46.2866 42.02 48.1366 40.6667L90.3333 16.5267L90.3666 11.3033C90.371 10.5081 90.2182 9.71977 89.917 8.98374C89.6159 8.2477 89.1722 7.57843 88.6115 7.01439C88.0509 6.45034 87.3843 6.00263 86.6501 5.69698C85.9159 5.39133 85.1286 5.23376 84.3333 5.23334Z",
    fill: "#EEC590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6933 83.38L41.5366 94.7667",
    stroke: "#94CDE2",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8169 93.5467L57.5936 88.36",
    stroke: "#94CDE2",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0001 70.9034L87.4567 82.3334C87.5186 82.3523 87.5855 82.3461 87.6428 82.3161C87.7002 82.2862 87.7435 82.235 87.7634 82.1734L100 44.9467C100.014 44.9016 100.014 44.8536 100.001 44.8082C99.9888 44.7628 99.9636 44.7219 99.9288 44.6902C99.894 44.6585 99.8509 44.6373 99.8045 44.629C99.7582 44.6207 99.7104 44.6257 99.6667 44.6434L48.9201 69.6434C48.7913 69.6964 48.6823 69.7885 48.6086 69.9066C48.5348 70.0248 48.4998 70.163 48.5087 70.3021C48.5175 70.4411 48.5696 70.5738 48.6578 70.6817C48.7459 70.7895 48.8656 70.8671 49.0001 70.9034Z",
    fill: "#94CDE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5132 73.7367L99.8232 44.63C99.8483 44.637 99.8719 44.6483 99.8932 44.6633L68.2265 76.6233L64.0965 90.13C64.0032 90.1133 63.9499 90.0933 63.8865 89.9133L58.5132 73.7367Z",
    fill: "#218BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3869 90.0166L76.3869 79.05L68.2335 76.6233L64.1035 90.13C64.1902 90.1533 64.2435 90.14 64.3869 90.0166Z",
    fill: "#3AB3E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentIcon);
export default __webpack_public_path__ + "static/media/email-sent-icon.781808b8538b3f450832bd45a9167fd8.svg";
export { ForwardRef as ReactComponent };